export default __webpack_public_path__ + "static/media/xls.20db4023.svg";